import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';

const CtaButtonWidget = ({ label, link, containerSettings }) => (
  <Container className="text-center" settings={containerSettings}>
    <div className="container">
      <a href={link} className="btn-primary">{label}</a>
    </div>
  </Container>
);

CtaButtonWidget.title = 'CTA Button';
CtaButtonWidget.preview = 'text.png';
CtaButtonWidget.category = 'Content';

CtaButtonWidget.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

CtaButtonWidget.defaults = {
  label: 'Button Label',
  link: '#',
  containerSettings: {},
};

CtaButtonWidget.adminFields = {
  label: { type: 'text' },
  link: { type: 'text' },
};

export default CtaButtonWidget;
